<template>
  <div class="table-support">
    <v-simple-table class="pb-5 table-support"
    height="700px">
      <thead>
        <tr>
          <th class="text-left" >Người tạo</th>
          <th class="text-left time" >Ngày tạo</th>
          <th class="text-left" >Mã KH</th>
          <th class="text-left" >SĐT</th>
          <th class="text-left" >Mã ĐH / Phiếu thu</th>
          <th class="text-left" >Nhóm ticket</th>
          <th class="text-left" >Loại ticket</th>
          <th class="th_status text-left" style="min-width: 300px">Mô tả</th>
          <th class="text-left" >Người xử lý</th>
          <th class="text-left" >Trạng thái xử lý</th>
          <th class="text-left" >Kết quả</th>
          <th class="text-left" >Lý do hủy</th>
          <th class="text-left content" >Nội dung xử lý</th>
          <th class="text-left" >Trạng thái gửi</th>
          <th class="text-left content" >Ticket ID</th>
          <th class="text-left content text-no-wrap" >Ngày cập nhật</th>
        </tr>
      </thead>
      <tbody v-for="(item, index) in requestList" :key="index">
        <tr>
          <td style="width: 10%;"  class="text-left">{{ item.createdBy.username || "_" }}</td>
          <td class="text-left">{{ formatDate(item.createdAt) || "_" }}</td>
          <td class="text-left">
            {{ item.customFields.customerCode || "_" }}
          </td>
          <td class="text-left">{{item.mobile || "_"}}</td>
          <td class="text-left">{{[item.customFields.orderCode, item.customFields.orderCode1, item.customFields.orderCode2, item.customFields.orderCode3].filter(Boolean).join(", ") || "-"}}</td>
          <td style="width: 10%;" class="text-left">{{ item.template.groupTicketName || "_" }}</td>
          <td style="width: 15%;" class="text-left">{{ item.template.typeTicketName || "_" }}</td>
          <td style="width: 15%; white-space: pre-line"  class="text-left">
            {{ item.customFields.description || "_" }}
          </td>
          <td style="width: 10%;" class="text-left">{{ item.handler || "_" }}</td>
          <td style="width: 10%;" class="text-left">
            <div
                class="ticket-status-box text-no-wrap"
                v-if="item.status && item.status.id"
                :style="`background: ${listTicketStatus.some((e) => e.value === item.status.name) ? listTicketStatus.find((e) => e.value === item.status.name).color : '#000000'}`"
                style="color: white">
              {{ item.status.name}}
            </div>
            <div v-else>
              _
            </div>
          </td>
          <td style="width: 10%;" class="text-left">{{ item.result || "_" }}</td>
          <td style="width: 10%;" class="text-left">{{ item.reasonCancel || "_" }}</td>
          <td style="min-width:350px" class="text-left">
            <template v-if="item.resultDetail">
              {{ item.resultDetail}}
            </template>
            <template v-if="!item.resultDetail && !item.resultAttachment.length">
              _
            </template>
            <span v-if="item.resultAttachment.length === 1">
            <a :href="item.resultAttachment[0]" target="_blank" style="color:#0d9aff;">
              Link
            </a>
          </span>
            <span v-else>
              <span v-for="(link, index) in item.resultAttachment" :key="index">
                <a :href="link" target="_blank" style="color:#0d9aff;">
                  Link {{ index + 1 }}
                </a>
                <span v-if="index < item.resultAttachment.length - 1">, </span>
               </span>
            </span>
          </td>
          <td style="width: 10%;" :class="{colorRed : item.bizflySyncStatus != 3 }" class="text-left">{{ item.bizflySyncStatus != 3 ? 'Chưa đồng bộ' : 'Đã đồng bộ'}}</td>
          <td class="text-left">
            <a :href="BIZFLY_DOMAIN + item.bizflyId" target="_blank" style="color: #0d9aff">{{item.bizflyId}}</a>
          </td>
          <td class="text-left">
            <template v-if="'bizflyLastUpdate' in item">
              {{ formatDate(item.bizflyLastUpdate) || "_" }}
            </template>
            <template v-else>_</template>
          </td>
        </tr>
      </tbody>
      <tbody v-if="requestList.length <= 0">
        <tr>
          <td colspan="100">
            <common-no-result />
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <div class="pb-3">
      <!--            <v-pagination-->
      <!--                v-if="totalItem > limit"-->
      <!--                v-model="currentPage"-->
      <!--                class="justify-sm-end"-->
      <!--                :length="getTotalItem(totalItem)"-->
      <!--                prev-icon="mdi-menu-left"-->
      <!--                next-icon="mdi-menu-right"-->
      <!--            />-->

      <v-col
        cols="12"
        md="12"
        class="pb-0"
        style="display: flex; justify-content: flex-end; padding: 0 12px"
      >
        <div class="text-right mb-1 mt-2">
          {{ showIndex() }}
          <v-btn
            small
            class="pagination-btn-left"
            @click="
              () => {
                currentPage--;
              }
            "
            :disabled="currentPage == 1"
          >
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn
            :disabled="(requestList.length < limit || currentPage * limit >= totalItem)"
            small
            class="pagination-btn-right"
            @click="
              () => {
                currentPage++;
              }
            "
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </div>
    <modal-view-file-attachment></modal-view-file-attachment>
  </div>
</template>

<script>
import moment from 'moment'
import RepositoryFactory from '../../../repositories/RepositoryFactory'
import {PRIORITY_SUPPORT, BIZFLY_DOMAIN} from "@/helpers/constants";
import ModalViewFileAttachment from "@/pages/support/components/ModalViewFileAttachment";
const SupportRepository = RepositoryFactory.get('support')
const TicketRepository = RepositoryFactory.get("ticket");
const ImageRepository = RepositoryFactory.get('image')

export default {
  props: {
    listTicketStatus: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ModalViewFileAttachment
  },
  data() {
        return {
            moduleId: null,
            currentPage: 1,
            requestList: [],
            statusList: [],
            totalItem: 0,
            limit: 20,
            filterForm: {
                mobile: '',
                startDateTime: moment().startOf('isoWeek').format('YYYY-MM-DD'),
                endDateTime: moment().endOf('isoWeek').format('YYYY-MM-DD')
            },
            file: {},
            stringBase64: '',
            requestSelected: {},
            PRIORITY_SUPPORT,
            BIZFLY_DOMAIN,
        }
    },
    async created() {
        this.filterForm.customerCode = this.$route.query?.nameCode || null
        this.filterForm.createdBy = this.$route.query?.createdBy || null
        if(this.$route.query?.createdAt){
          this.filterForm.activatedAt = [moment(this.$route.query?.createdAt).format('YYYY-MM-DD'), moment(this.$route.query?.createdAt).format('YYYY-MM-DD')]
        }
        if(this.$route.query?.nameCode){
          await this.getListSupportV2()
        } else {
          await this.getTicketSystemModule()
        }
        Bus.$on('search-request-support-list-3', filterForm => {
            this.filterForm = filterForm
            this.currentPage = 1
            this.getTicketSystemModule()
        })
        Bus.$on('refresh-ticket-v2', async () => {
          if(this.moduleId){
            await this.getTicketSystemModule()
          }
        })
    },
    beforeDestroy() {
        Bus.$off('search-request-support-list-3')
        // Bus.$off('fetch-table-while-change-tab5')
        Bus.$off('refresh-ticket-v2')
    },
    watch: {
        currentPage: {
            handler() {
                this.getListSupportV2()
            }
        }
    },
    methods: {
      async getTicketSystemModule() {
            const params = {
                typeId: this.$store.state.module.typeId,
                schoolLevelId: this.$store.state.module.schoolLevelId,
            }
            try{
                const response = await TicketRepository.getTicketSystemModuleApi(params)
                if(response.success) {
                    this.moduleId = response.data ? response.data.moduleId : '';
                    if(this.moduleId) {
                     await this.getListSupportV2()
                    } else {
                      this.requestList = []
                    }
                }
            }catch (e) {
                console.log(e)
            }
        },
         renderPriority(value){
            let priority = _.find(this.PRIORITY_SUPPORT, {value: value})
            return priority?.name || '_'
        },
        async getListSupportV2(){
          const params = {
            'systemId':1,
            'moduleId': this.moduleId,
            "id": this.filterForm.id || null,
            "status": this.filterForm.statusSupportId || null,
            "typeTicketName": this.filterForm.ticketTypeId || null,
            "groupTicketName": this.filterForm.ticketGroupId || null,
            "customerCode": this.filterForm.customerCode || null,
            "nameCode": this.filterForm.createdBy || null,
            "startDate" : this.filterForm.activatedAt?.length ? this.filterForm.activatedAt[0] : null,
            "endDate" : this.filterForm.activatedAt?.length ? this.filterForm.activatedAt[1] : null,
            "mobile": this.filterForm.mobile || null,
            "orderCode": this.filterForm.orderCode || null,
            "ticketBizflyId": this.filterForm.ticketId || null,
            limit: this.limit,
            page: this.currentPage,
          };
          const loading = this.$loading.show()
          let res = await SupportRepository.getListSupportsV3(params);
          if (res.success) {
            this.requestList = _.get(res, "data", []);
            this.totalItem = _.get(res, "totalItem", 0);
          } else {
            this.requestList = [];
          }
          loading.hide()
        },
        formatDate(date) {
            if (date) {
                return moment(date).format('HH:mm:ss DD/MM/YYYY')
            } else {
                return ''
            }
        },
      showIndex() {
        if (this.requestList.length > 0) {
          let maxIndex = this.requestList.length < this.limit ? parseInt(this.currentPage - 1) * parseInt(this.limit) + this.requestList.length : parseInt(this.currentPage) * parseInt(this.limit)
          return this.requestList.length < this.limit ? (maxIndex - parseInt(this.requestList.length) + 1) + ' - ' + maxIndex : (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
        } else {
          return ('0 - 0')
        }
      },
    }
}
</script>

<style scoped>
.ticket-status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 5px;
  width: fit-content;
}
/deep/table tr th {
  text-align: center !important;
  border-bottom: 1px solid #8e8e8e !important;
  height: 30px;
  font-weight: 900 !important;
  padding: 20px 0;
  color: #777777 !important;
  font-size: 14px !important;
  padding: 15px !important;
  position: sticky;
  top: 0;
  background-color: #fff !important;
}

/deep/table tr th.content {
  width: 300px;
  text-wrap: wrap;
}
/deep/table tr th.time {
  width: 100px;
  text-wrap: wrap;
}

/deep/table tr td {
  border-bottom: 1px solid #8e8e8e !important;
  height: 35px !important;
  padding: 15px !important;
  font-weight: 500 !important;
  color: #777777 !important;
  font-size: 12px !important;
}

.th_mobile {
  width: 110px;
}

.th_status {
  width: 130px;
}

.td_request {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 250px;
}

.td_urgent {
  max-width: 150px !important;
  min-width: 100px !important;
}
.file-icon {
  transform: rotate(-45deg);
}
</style>
<style lang="scss">
.table-support {
  table {
    display: block;
    overflow-x: auto;
    height: 700px;
    th {
      white-space: nowrap;
    }
  }
}
</style>